import { useEffect, useRef } from 'react';

import trackEvent from '../utils/fathom';

const MIN_DWELL_SECONDS = 2;

const useDetailViewTracking = ({ type, nid, enabled }) => {
  const startedAtRef = useRef(null);

  useEffect(() => {
    if (!enabled || !type || !nid) return undefined;

    startedAtRef.current = Date.now();

    return () => {
      const startedAt = startedAtRef.current;
      startedAtRef.current = null;
      if (!startedAt) return;

      const elapsedSeconds = Math.round((Date.now() - startedAt) / 1000);
      if (elapsedSeconds < MIN_DWELL_SECONDS) return;

      trackEvent(`pib ${type} view: ${nid}`, elapsedSeconds);
    };
  }, [type, nid, enabled]);
};

export default useDetailViewTracking;
